export default class BaseAccordionPanel {
    panelOpen = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('accordionPanel', () => new BaseAccordionPanel());
});
